<ct-lib-info-banner>
  <span [innerHTML]="'jobboard.platform.settings.tfa.info' | transloco: { url: tfaHelpUrl }"></span>
</ct-lib-info-banner>
<div class="table-wrapper">
  <div class="actions">
    <app-button [iconStart]="icons.plus" (click)="openAddMethod()">
      {{ 'jobboard.platform.settings.tfa.add-method' | transloco }}
    </app-button>
  </div>
  <p-table class="tfa-table" [value]="tfaService.methods()">
    <ng-template #header>
      <tr>
        <th>{{ 'jobboard.platform.settings.tfa.table.name' | transloco }}</th>
        <th>{{ 'jobboard.platform.settings.tfa.table.method' | transloco }}</th>
        <th>{{ 'jobboard.platform.settings.tfa.table.created-on' | transloco }}</th>
        <th>{{ 'jobboard.platform.settings.tfa.table.last-used-on' | transloco }}</th>
        <th></th>
      </tr>
    </ng-template>
    <ng-template #body let-tfaMethod>
      <tr>
        <td>{{ tfaMethod.name }}</td>
        @switch (tfaMethod.type) {
          @case (methodTypes.APP) {
            <td class="method">
              <fa-icon [icon]="icons.mobile" size="lg"></fa-icon>
              {{ 'jobboard.platform.settings.tfa.table.methods.app' | transloco }}
            </td>
          }
          @case (methodTypes.KEY) {
            <td class="method">
              <fa-icon [icon]="icons.usbDrive" size="lg"></fa-icon>
              {{ 'jobboard.platform.settings.tfa.table.methods.cross-platform' | transloco }}
            </td>
          }
          @case (methodTypes.OS) {
            <td class="method">
              <fa-icon [icon]="icons.desktop" size="lg"></fa-icon>
              {{ 'jobboard.platform.settings.tfa.table.methods.platform' | transloco }}
            </td>
          }
        }
        <td>{{ tfaMethod.created | date: 'shortDate' }}</td>
        <td>{{ tfaMethod.lastUsed | date: 'shortDate' }}</td>
        <td class="actions">
          <app-button
            variant="ghost"
            [round]="true"
            [small]="true"
            [iconStart]="icons.trash"
            class="text-red"
            [ariaLabel]="'jobboard.platform.settings.tfa.table.remove-aria' | transloco"
            (click)="deleteMethodModal.modal.open()"
          ></app-button>
          <ct-lib-confirm-modal (onConfirm)="onDeleteMethod(tfaMethod)" #deleteMethodModal>
            <span
              [innerHTML]="
                'jobboard.platform.settings.tfa.table.delete-text' | transloco: { name: tfaMethod.name }
              "
            ></span>
          </ct-lib-confirm-modal>
        </td>
      </tr>
    </ng-template>
  </p-table>
  @if (!tfaService.methods().length) {
    <ct-lib-empty-placeholder
      [title]="'jobboard.platform.settings.tfa.table.no-methods' | transloco"
      text=""
      [icon]="icons.shieldKeyhole"
      @illustration
    ></ct-lib-empty-placeholder>
  }
</div>
<app-platform-add-tfa-modal #addMethodModal></app-platform-add-tfa-modal>
